import PropertiesIcon from "@mui/icons-material/SettingsOutlined";
import AlertsIcon from "@mui/icons-material/NewReleasesOutlined";
import TagsIcon from "@mui/icons-material/LocalOfferOutlined";

import StackDetails from "./StackDetails";
import StackAlerts from "./StackAlerts";
import StackTagsConfig from "./StackTagsConfig";

export const ACTION_NONE = -1;
export const ACTION_STACK_DETAILS = 0;
export const ACTION_STACK_ALERTS = 1;
export const ACTION_STACK_TAGS_CONFIG = 2;

export const STACKS_MANAGEMENT_ACTIONS = (isxContext) => [
  {
    id: ACTION_STACK_ALERTS,
    label: "Manage Alerts",
    icon: AlertsIcon,
    component: StackAlerts,
  },
  {
    id: ACTION_STACK_TAGS_CONFIG,
    label: "Manage Tags",
    icon: TagsIcon,
    component: StackTagsConfig,
  },
  {
    id: ACTION_STACK_DETAILS,
    label: `Manage ${isxContext.labels.deviceCapitalized ?? "Stack"}`,
    icon: PropertiesIcon,
    component: StackDetails,
  },
];
